import { render, staticRenderFns } from "./resource_page.vue?vue&type=template&id=daaafc08&scoped=true"
import script from "./resource_page.vue?vue&type=script&lang=js"
export * from "./resource_page.vue?vue&type=script&lang=js"
import style0 from "./resource_page.vue?vue&type=style&index=0&id=daaafc08&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daaafc08",
  null
  
)

export default component.exports